import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, inject } from '@angular/core';

import { I18nPipe } from '../../pipes/i18n.pipe';
import { PlanService } from '../../../core/services/plan.service';
import { PlanHistoryEntry } from '../../../core/models/plan.model';

@Component({
  selector: 'umkt-plan-history-modal',
  standalone: true,
  imports: [CommonModule, I18nPipe],
  templateUrl: './plan-history-modal.component.html',
  styleUrls: ['./plan-history-modal.component.scss'],
})
export class PlanHistoryModalComponent implements OnChanges {
  @Input() open = false;
  @Input() planUuid = '';
  @Input() productName = '';

  @Output() closed = new EventEmitter<void>();

  history: PlanHistoryEntry[] = [];
  isLoading = false;
  hasError = false;
  private planService = inject(PlanService);


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['open']?.currentValue === true && this.planUuid) {
      this.loadHistory();
    }
  }

  private loadHistory(): void {
    this.isLoading = true;
    this.hasError = false;
    this.planService.getPlanHistory(this.planUuid).subscribe({
      next: (response) => {
        this.history = response.data ?? [];
        this.isLoading = false;
      },
      error: () => {
        this.hasError = true;
        this.isLoading = false;
      },
    });
  }

  get actionKey(): (action: PlanHistoryEntry['action']) => string {
    return (action) => `pages.planDetails.PlanHistoryModal.actions.${action}`;
  }

  close(): void {
    this.closed.emit();
  }
}
